import classNames from "classnames";
import { KeyboardEventHandler, forwardRef } from "react";
import styles from "./Hamburger.module.css";
import { useWebTranslation } from "translations";

export const Hamburger = forwardRef<
  HTMLButtonElement,
  {
    isOpen: boolean;
    onClick: () => void;
    onKeyDown: KeyboardEventHandler<HTMLButtonElement>;
    /** The id of the menu panel this button opens. */
    controls: string;
  }
>(function Hamburger({ isOpen, onClick, onKeyDown, controls }, ref) {
  const { t } = useWebTranslation();

  return (
    <button
      ref={ref}
      onClick={onClick}
      onKeyDown={onKeyDown}
      className={styles.container}
      aria-label={t("a11y.signup.toggle_menu")}
      aria-expanded={isOpen}
      aria-controls={controls}
    >
      <div
        style={{
          transform: isOpen
            ? "translate(2px) rotate(45deg)"
            : "translate(0) rotate(0)",
        }}
        className={classNames(styles.bar, styles.barTop)}
      ></div>
      <div
        style={{
          transform: isOpen
            ? "translate(2px) rotate(-45deg)"
            : "translate(0) rotate(0)",
        }}
        className={classNames(styles.bar, styles.barBottom)}
      />
    </button>
  );
});
